import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("auth_token");
  if (t && cfg.url?.startsWith(API) && !cfg.headers?.Authorization) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${t}` };
  return cfg;
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [profile, setProfile] = useState(undefined); // undefined = checking, null = signed out
  const refresh = useCallback(async () => {
    if (!localStorage.getItem("auth_token")) return setProfile(null);
    try {
      const { data } = await axios.get(`${API}/me/profile`);
      setProfile(data);
    } catch (e) {
      if (e.response?.status === 401) localStorage.removeItem("auth_token");
      setProfile(null);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const signIn = async (mode, body) => {
    const { data } = await axios.post(`${API}/auth/${mode}`, body);
    localStorage.setItem("auth_token", data.token);
    await refresh();
  };
  const signOut = () => { localStorage.removeItem("auth_token"); setProfile(null); };
  const setWatchlist = async (ids) => {
    const { data } = await axios.put(`${API}/me/watchlist`, { watchlist: ids });
    setProfile((p) => ({ ...p, watchlist: data.watchlist }));
  };
  const toggleWatch = async (id) => {
    const w = profile?.watchlist || [];
    await setWatchlist(w.includes(id) ? w.filter((x) => x !== id) : [...w, id]);
  };
  const viewed = async (id) => {
    if (!profile) return;
    const { data } = await axios.post(`${API}/me/recent`, { asset: id });
    setProfile((p) => ({ ...p, recent: data.recent }));
  };
  return <Ctx.Provider value={{ profile, user: profile, refresh, signIn, signOut, toggleWatch, viewed, isPro: !!profile?.plan && profile.plan !== "free", tier: profile?.plan || "free" }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
